import * as React from "react";
import { observable, action } from "mobx";
import { inject, observer } from "mobx-react";
import { ILocalization } from "../../../models/localization";
import { hashHistory } from "react-router";
import { ApplicationProcess } from "../../../models/enums";
import { Opportunity } from "../../../models/opportunity";
import SeekerStore from "../../../stores/seekerStore";
import { Row, Col } from "react-flexbox-grid";
import * as s from "./opLabel.css";

export class ApplyNowLabel extends React.Component<{store:SeekerStore, op:Opportunity}, {}> {

  constructor(props: any) {
    super(props);
  }
  clickThrough = (): void => {
    const f: (op?: Opportunity) => void = this.props.store.opportunityStore.getApplicationFunction(this.props.op);
    f(this.props.op);
  }
  render(): JSX.Element {
    return<p onClick={this.clickThrough} className={s.apply}> {this.props.store.localization.fields.applyNow.toUpperCase()}</p>  
  }
}

export class NewLabel extends React.Component<{store:SeekerStore}, {}> {

  constructor(props: any) {
    super(props);
  }

  render(): JSX.Element {
    return <p className={s.newLabel}>{this.props.store.localization.fields.newOp.toUpperCase()}</p>;
  }
}

@observer
export class AppliedLabel extends React.Component<{ store: SeekerStore}, {}> {

  constructor(props: any) {
    super(props);
  }

  render(): JSX.Element {
    return <p className={s.applied}>{this.props.store.localization.fields.appliedCheck}</p>;
  }
}

@observer
export class Score extends React.Component<{ store:SeekerStore, score: number}, {}> {

  constructor(props: any) {
    super(props);
  }

  render(): JSX.Element {
    const local: ILocalization = this.props.store.localization.fields;
    return <p className={s.score}>{local.scoreLabel.toUpperCase()}&nbsp;{this.props.score}</p>;
  }
}


@observer
export class FeaturedLabel extends React.Component<{ store: SeekerStore, op: Opportunity, isNew: boolean, allowApply: boolean}, {}> {

  constructor(props: any) {
    super(props);
  }

  render(): JSX.Element {
    return <div className={s.container}>
      {this.props.isNew && < NewLabel store={this.props.store} />}
      {this.props.allowApply && < ApplyNowLabel store={this.props.store} op={this.props.op} />}
    </div>;
  }
}


@observer
export class OpLabels extends React.Component<{ isNew: boolean, allowApply: boolean, applied: boolean, score: number, store:SeekerStore, op:Opportunity}, {}> {

  constructor(props: any) {
    super(props);
  }

  render(): JSX.Element {
    return <div className={s.container}>
      {!isNaN(this.props.score) && <Score score={this.props.score} store={this.props.store} />}
      {this.props.isNew && <NewLabel store={this.props.store} />}
      {this.props.allowApply && !this.props.applied && <ApplyNowLabel store={this.props.store} op={this.props.op} />}
      {this.props.applied && <AppliedLabel store={this.props.store} />}
      </div>;
  }
}



// WEBPACK FOOTER //
// ./src/components/widgets/opLabels/index.tsx